<template lang="pug">
.page-exhibition.text-left.lexus-2023
  .container.pb-5.mt-md-5
    .row
      .col-lg-6.col-xl-5.px-4.px-md-5.h-100
        .mt-lg-5
        h1.text-center.pt-4 {{ $t('exhibitionPages.lexus2023.title') }}
        p.text-center.pb-3 {{ $t('exhibitionPages.lexus2023.date') }}
        hr
        p.poem.lines {{ $t('exhibitionPages.lexus2023.poem') }}
        p.mt-2 {{ $t('exhibitionPages.lexus2023.description') }}
        p.mt-3.lines {{ $t('exhibitionPages.lexus2023.englishPoem') }}
        .mt-5
          p.float-none.float-md-right.text-center
            //- | Che-Yu Wu 吳哲宇
            a(href="https://www.instagram.com/cheyuwu345/", target="_blank")
              img.sign(
                src="/static/img/cheyuwu/CHEYUWU__Primary Logo_White.png"
              )
      .col-lg-6.col-xl-7.order-first.order-md-last.p-0.p-md-3.p-lg-5
        iframe#work(
          ref="workIframe",
          src="/static/231121_UrbanContour/"
        )
</template>

<script>
import { useI18n } from 'vue-i18n'
import socialLinks from "@/components/socialLinks.vue";

export default {
  setup() {
    const { t } = useI18n()
    return { t }
  },
  metaInfo() {
    return {
      title: `${this.t('exhibitionPages.lexus2023.title')} 與 Lexus 驚探生活誌的雜誌封面共創`,
      meta: [
        {
          property: "og:image",
          content: "/static/img/city.jpeg",
        },
      ],
    };
  },
  mounted() {
    setInterval(() => {
      this.$refs.workIframe.contentWindow.location.reload(true);
    }, 15000);
  },
  // computed: {
  //   workName() {
  //     return this.$route.params.name;
  //   },
  // },
  components: {
    "social-links": socialLinks,
  },
  //   ElectrizDemo,
  //   PageNftElectriz,
  //   PageNftSoulFish,
  //   PageNftFoundation,
  //   PageNftTheSoul,
  // },
};
</script>

<style lang="sass">
// @import url('https://fonts.googleapis.com/css2?family=Rokkitt:wght@100;200;300;400;500;600;700;800;900&display=swap')
.page-exhibition.lexus-2023
  background-color: var(--bg0)
  color: var(--ink)
  min-height: 100vh
  overflow-x: hidden
  font-family: serif
  // 詩的換行寫在 i18n 字串裡（\n），用 pre-line 顯示，不走 v-html
  .lines
    white-space: pre-line
  .container
    max-width: 2000px
  h2
    font-size: 2.1rem
    font-family: serif
  pre
    color: rgba(255,255,255,0.9)

  .poem
    font-size: 1.2rem
    font-family: serif
    letter-spacing: 0.05em

  hr
    border: solid 0.5px var(--ink)
    margin-bottom: 30px
  iframe
    width: 100%
    aspect-ratio: 5/6
    border: none
  .sign
    width: 100%
    max-width: 300px

  .social-links
    a
      color: white
      margin-left: 6px
      margin-right: 6px
      font-size: 2rem
      transition: var(--t-hover)
      display: none
      &:hover i
        transform: scale(1.2)

      &:nth-child(2)
        display: block
</style>
